export const config = {
  default: "OK",
  OK: {
    color: "green",
    title: "OK"
  },
  NOK: {
    color: "red",
    title: "NOK"
  }
}
